import { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import { FeedbackModal } from './FeedbackModal';

interface FeedbackButtonProps {
  collapsed?: boolean;
}

export function FeedbackButton({ collapsed = false }: FeedbackButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        data-demo-id="feedback-button"
        onClick={() => setIsOpen(true)}
        title={collapsed ? 'Send feedback' : undefined}
        className={`flex items-center gap-3 w-full px-3 py-2 rounded-xl text-meta text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/[0.06] transition-all ${
          collapsed ? 'justify-center' : ''
        }`}
      >
        <MessageSquare className="h-4 w-4 flex-shrink-0" />
        {!collapsed && <span>Feedback</span>}
      </button>

      <FeedbackModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
